export const downloadButton = {
    height: "fit-content",
};

export const LinkInput = {
    "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent !important",
    },
};
